
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("29ZX6", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=pt-BR.f1c8f788.js.map
